module.exports = __webpack_public_path__ + "static/media/intro.14c31f7b.mp3";